import { Injectable, OnDestroy, inject } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

import { SDK } from '@plugins/middleware-sdk';

export type GlobalSave = (saved: boolean) => void;
export type GlobalSaveHandler = (done?: GlobalSave) => void;

export abstract class GlobalSaveServiceToken {
  abstract get globalSave(): boolean;
  abstract addSaveHandler(saveHandler: GlobalSaveHandler): void;
  abstract removeSaveHandler(saveHandler: GlobalSaveHandler): void;
}

@Injectable({
  providedIn: 'root',
})
export class GlobalSaveService
  extends GlobalSaveServiceToken
  implements OnDestroy
{
  #sdk = inject(SDK);

  #globalSave = false;
  #saveHandlers: GlobalSaveHandler[] = [];
  #destroy$ = new Subject<void>();
  #destroySubscription?: Subscription;

  get globalSave() {
    return this.#globalSave;
  }

  constructor() {
    super();
    void this.#sdk
      .onSave((done) => {
        this.#handleSave(done);
      })
      .then(({ hideControls, disconnect }) => {
        this.#globalSave = hideControls;
        this.#destroySubscription = this.#destroy$.subscribe(() => {
          disconnect();
        });
      });
  }

  #handleSave(done: (saved: boolean) => void) {
    this.#saveHandlers.at(-1)?.(done);
  }

  addSaveHandler(saveHandler: GlobalSaveHandler) {
    this.#saveHandlers.push(saveHandler);
  }

  removeSaveHandler(saveHandler: GlobalSaveHandler) {
    this.#saveHandlers = this.#saveHandlers.filter((h) => h !== saveHandler);
  }

  ngOnDestroy() {
    this.#destroy$.next();
    this.#destroy$.complete();
    this.#destroySubscription?.unsubscribe();
  }
}

@Injectable({ providedIn: 'root' })
export class TestGlobalSaveService extends GlobalSaveServiceToken {
  get globalSave(): boolean {
    return true;
  }
  addSaveHandler(saveHandler: GlobalSaveHandler) {
    return;
  }
  removeSaveHandler(saveHandler: GlobalSaveHandler): void {
    return;
  }
}
